import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import GameCard from '../../components/GameCard/GameCard';
import AdBanner from '../../components/ADS/AdBanner';
import AdCMP from '../../components/ADS/AdCMP';
import PremiumGames from '../Games/PremiumGames';
import { fetchGamezopGames } from '../../services/gameService';
import { AD_SLOTS, getCategoryIcon, slugify } from '../../utils/constants';

function Category() {
  const { name } = useParams();
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);

  const displayName = name?.replaceAll('-', ' ');
  const titleCase = displayName?.replace(/\b\w/g, l => l.toUpperCase());
  const icon = getCategoryIcon(name);

  useEffect(() => {
    setLoading(true);
    fetchGamezopGames()
      .then(games => setState(name === 'all-games' ? games : games.filter(
        g => g?.categories?.en[0]?.toLowerCase().replace(/\s+/g, '-') === name
      )))
      .catch(() => setState([]))
      .finally(() => setLoading(false));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [name]);

  return (
    <>
      <Helmet>
        <title>{`${titleCase} Games — Play Free Online |Car Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online`}</title>
        <meta name="description" content={`Play free ${displayName} games atCar Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online. No download required!`} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={`${titleCase} Games |Car Games - Play Free Driving and Racing Games Online |Car Games - Free Driving and Racing Games Online`} />
        <meta property="og:url" content={`https://cargames.site/category/${name}`} />
        <meta property="og:image" content="https://cargames.site/logo.png" />
        <link rel="canonical" href={`https://cargames.site/category/${name}`} />
      </Helmet>

      <div className="p-4">
        <AdBanner className="mb-4" />

        {/* Header */}
        <div className="flex items-center justify-between mb-5 p-4 rounded-2xl card">
          <div className="flex items-center gap-3.5">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0 bg-gradient-to-br from-[#4f8ef7] to-[#a855f7]">
              {icon}
            </div>
            <div>
              <h1 className="font-extrabold text-xl m-0 font-sora text-main">{titleCase} Games</h1>
              <p className="text-xs font-semibold mt-0.5 m-0 text-dim">
                {loading ? 'Loading...' : `${state.length} games available`}
              </p>
            </div>
          </div>
          <Link to="/category/all-games" className="btn-outline hidden sm:flex">All Games →</Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-7 xl:grid-cols-9 2xl:grid-cols-11 gap-2 sm:gap-3">
          {loading && Array(18).fill(0).map((_, i) => (
            <div key={i} className="rounded-xl skeleton aspect-square" />
          ))}
          {!loading && state.map((_ele, i) => (
            <GameCard key={i} slug={slugify(_ele?.name?.en)} name={_ele?.name?.en} banner={_ele?.assets?.square} />
          ))}
          {!loading && state.length === 0 && (
            <div className="col-span-full text-center py-16">
              <div className="text-5xl mb-3">😕</div>
              <h2 className="text-lg font-extrabold mb-2 text-main">No Games Found</h2>
              <Link to="/category/all-games" className="text-sm font-bold text-accent-color">Browse all games →</Link>
            </div>
          )}
        </div>

        <AdBanner className="my-6" />

        {/* Premium */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3.5">
            <h2 className="font-extrabold text-lg flex items-center gap-2 font-sora text-main">⭐ Premium Games</h2>
            <Link to="/category/all-games" className="text-xs font-bold text-accent-color no-underline">View All →</Link>
          </div>
          <PremiumGames flag={48} />
        </div>

        {/* Bottom ads */}
        <div className="grid grid-cols-1 xl:grid-cols-4 gap-4">
          <div className="xl:col-span-3"><AdBanner /></div>
          <div className="xl:col-span-1 hidden xl:flex flex-col items-center justify-center rounded-xl p-2 bg-secondary-theme border-dashed-theme min-h-[270px]">
            <span className="ad-label">Advertisement</span>
            <AdCMP adSize="300x250" dataAdSlot={AD_SLOTS['300x250']} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Category;
